"use client";
import { useState } from "react";
import Link from "next/link";
import CustomButton from "../Buttons/CustomButton";
import cl1Tab from "@/Helper/images/client_centric_approach.png";
import cl2Tab from "@/Helper/images/commitment_to_innovation.png";
import cl3Tab from "@/Helper/images/ethical_data_practices.png";
import cl4Tab from "@/Helper/images/end_to_end_expertise.png";

import Image from "next/image";

export default function IndustryComponent() {
  const [activeTab, setActiveTab] = useState(0); // State for active tab

  const handleTabClick = (index) => {
    setActiveTab(index); // Update the active tab state
  };

  const tabTitles = [
    "Education expertise",
    "Proven impact on student success",
    "Comprehensive, end-to-end service",
    "Data security & compliance",
    "Scalable solutions for all education levels",

  ];

  const tabContent = [
    {
      heading: "Education expertise",
      subheading: "With extensive experience in the education sector, we understand the challenges and priorities of institutions and offer analytics solutions that are designed to improve student outcomes and operational efficiency.",
      image: cl1Tab,
    },
    {
      heading: "Proven impact on student success",
      subheading: " Our analytics solutions are designed to deliver real results, from boosting engagement to reducing dropout rates, improving resource allocation, and enhancing communication with parents. ",
      image: cl2Tab,
    },
    {
      heading: "Comprehensive, end-to-end service",
      subheading: " We handle every stage of the analytics journey—from data integration and insight generation to implementation and ongoing support—providing an all-encompassing solution for educational analytics.",
      image: cl3Tab,
    },
    {
      heading: "Data security & compliance",
      subheading: "We understand the importance of data security and compliance in education. Our solutions prioritize data privacy, safeguarding student and institutional information while meeting regulatory requirements.",
      image: cl4Tab,
    },
    {
      heading: "Scalable solutions for all education levels",
      subheading: "Our solutions are adaptable for K-12 schools, higher education institutions, and other educational organizations, providing scalable analytics that grow with your needs.",
      image: cl4Tab,
    },

  ];

  return (
    <div className="industry_cat_section1">
      {/* Navigation Tabs */}
      <div className="industry_cat_nav1">
        {tabTitles.map((tab, index) => (
          <p
            key={index}
            className={index === activeTab ? "active" : ""}
            onClick={() => handleTabClick(index)}

          >
            {tab}
          </p>
        ))}
      </div>

      {/* Tab Content */}
      {tabContent.map((content, index) => (
        <div
          key={index}
          className={`industry_container1 ${index === activeTab ? "active" : ""
            }`}
        >
          <div className="industry_left_content1">
            <p className="heading1">{content.heading}</p>
            <p className="subheading1">{content.subheading}</p>

          </div>
          <div className="industry_right_content1">
            <div className="slider_bg1 normal_bg1">
              <Image
                src={tabContent[activeTab].image}
                alt={tabContent[activeTab].heading}
                width={457}
                height={257}
                className="productbanner_imageslider"
                loading="eager"
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
